import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		component: () => import('@/views/index'),
		name: 'index',
		meta: {
			title: '首页'
		}
	}, {
		path: '/file',
		component: () => import('@/views/file'),
		name: 'file',
		meta: {
			title: '隐私政策'
		}
	}, {
		path: '/login',
		component: () => import('@/views/login'),
		name: 'login',
		meta: {
			title: '登录'
		}
	}, {
		path: '/learn',
		component: () => import('@/views/lesson/learn'),
		name: 'learn',
		meta: {
			title: '课程'
		}
	},{
		path: '/collecting',
		component: () => import('@/views/collecting/index'),
		hidden: true
	},
	{
		path: '/collecting/details',
		component: () => import('@/views/collecting/details'),
		hidden: true
	}, {
		path: '/purchase',
		component: () => import('@/views/learnCode/purchase'),
		name: 'purchase',
		meta: {
			title: '苏学码购买'
		}
	}, {
		path: '/payCode',
		component: () => import('@/views/learnCode/payCode'),
		name: 'payCode',
		meta: {
			title: '支付'
		}
	}, {
		path: '/profile',
		component: () => import('@/views/userCenter/profile'),
		name: 'profile',
		meta: {
			title: '个人中心'
		}
	}, {
		path: '/exam',
		component: () => import('@/views/lesson/exam'),
		name: 'exam',
		meta: {
			title: '考试'
		}
	}, {
		path: '/register',
		component: () => import('@/views/register/index'),
		name: 'register',
		meta: {
			title: '注册'
		}
	}, {
		path: '/password',
		component: () => import('@/views/register/password'),
		name: 'password',
		meta: {
			title: '找回密码'
		}
	}]
})